"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIAddress = void 0;
const iaddress_location_1 = require("./iaddress-location");
function parseIAddress(data) {
    if (data.location !== null && typeof data.location === 'object')
        data.location = (0, iaddress_location_1.parseIAddressLocation)(data.location);
    return data;
}
exports.parseIAddress = parseIAddress;
